/** @jsxImportSource @emotion/react */
import React from 'react'
import { OurWorkForm, OurWorkPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/OurWorkContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, ourWorkManagement } = breadcrumbItems

const OurWorkCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <OurWorkForm />
        </div>
        <div css={styles.right}>
          <OurWorkPreview />
        </div>
      </div>
    </Provider>
  )
}

export default OurWorkCreate;
